<template>
  <div>
    <div id="publicTop" class="public-top">
      <div class="w1200 topbar">
        <div class="user-entry f-l" v-if="membername">
          <span
            >您好 <a :href="userLink" target="_blank">{{ membername }}</a
            >,欢迎来到</span
          ><a :href="CurrentEnvPrefix.main" target="_blank">找家纺</a
          ><span> [ <a href="javascript:;" @click="goout()">退出</a> ] </span>
        </div>
        <div class="user-entry f-l" v-else>
          <a :href="CurrentEnvPrefix.main" target="_blank">找家纺</a
          ><span>欢迎你！</span>
          <a
            :href="CurrentEnvPrefix.login + '/?ref_url=' + ref_url"
            style="margin-left:20px;"
            >登录</a
          >
          <span
            ><a
              :href="CurrentEnvPrefix.login + '/login/login/register'"
              style="margin-left:20px;"
              >免费注册</a
            ></span
          >
        </div>

        <div class="quick-menu f-r">
          <ul class="qm-ul">
            <!--<li class="qm-ul-li">-->
            <!--  <div class="qm-ch-div">-->
            <!--    <a-->
            <!--      :href="-->
            <!--        CurrentEnvPrefix.main +-->
            <!--          '/shop/index.php?act=images&op=index'-->
            <!--      "-->
            <!--      target="_blank"-->
            <!--      >数据包生成</a-->
            <!--    >-->
            <!--  </div>-->
            <!--</li>-->
            <li class="qm-ul-li">
              <div class="qm-ch-div">
                <a href="javascript:;"
                  >功能服务 <i class="fa fa-angle-down" aria-hidden="true"></i
                ></a>
              </div>
              <div class="qm-ch-div1">
                <ul class="qm-ch-ul">
                  <li>
                    <a href="javascript:;"
                      ><label
                        >以图搜款<input
                          type="file"
                          id="file"
                          name="card_z"
                          accept="image/png,image/jpeg,image/gif"
                          class="input-file"
                          hidefocus="true"
                          @change="uploadChange"
                          ref="upload"/></label
                    ></a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="qm-ul-li">
              <div class="qm-ch-div">
                <a href="javascript:;"
                  >我是商家 <i class="fa fa-angle-down" aria-hidden="true"></i
                ></a>
              </div>
              <div class="qm-ch-div1">
                <ul class="qm-ch-ul">
                  <li>
                    <a
                      :href="
                        CurrentEnvPrefix.main +
                          '/shop/index.php?act=show_joinin&op=register_store'
                      "
                      target="_blank"
                      >招商入驻</a
                    >
                  </li>
                  <li>
                    <a :href="CurrentEnvPrefix.newMain + ''" target="_blank"
                      >商家登录</a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li class="qm-ul-li">
              <div class="qm-ch-div">
                <a href="javascript:;"
                  >我的商城 <i class="fa fa-angle-down" aria-hidden="true"></i
                ></a>
              </div>
              <div class="qm-ch-div1">
                <ul class="qm-ch-ul">
                  <!-- <li><a :href="CurrentEnvPrefix.member" target="_blank">待付款订单</a></li> -->
                  <li><a :href="orderListLink" target="_blank">订单列表</a></li>
                  <!-- <li><a :href="CurrentEnvPrefix.member" target="_blank">待评价交易</a></li>
										<li><a :href="CurrentEnvPrefix.member+'/member/memberinfo/message?is_old=1'" target="_blank">站内信<span>0</span>条</a></li>
										<li><a :href="CurrentEnvPrefix.member+'/member/customer/consult?is_old=1'" target="_blank">咨询与回复</a></li>
										<li><a :href="CurrentEnvPrefix.member+'/member/memberinfo/goodsbrowse?is_old=1'" target="_blank">浏览历史</a></li> -->
                </ul>
              </div>
            </li>
            <!-- <li class="qm-ul-li">
								<div class="qm-ch-div"><a href="javascript:;">我的收藏 <i class="fa fa-angle-down" aria-hidden="true"></i></a></div>
								<div class="qm-ch-div1">
									<ul class="qm-ch-ul">
										<li><a href="http://www.zhaojiafang.com/shop/index.php?act=member_favorites&op=fglist" target="_blank">商品收藏</a></li>
										<li><a href="http://www.zhaojiafang.com/shop/index.php?act=member_favorites&op=fslist" target="_blank">店铺收藏</a></li>
									</ul>
								</div>
							</li> -->
            <!-- <li class="qm-ul-li"><div class="qm-ch-div"><a href="http://search.zhaojiafang.com//search/index/transport?store_id=3071" target="_blank">运费测算</a></div></li> -->
            <li class="qm-ul-li qm-ul-li-wx">
              <div class="qm-ch-div">
                <a href="javascript:;"
                  >在线客服 <i class="fa fa-angle-down" aria-hidden="true"></i
                ></a>
              </div>
              <div class="qm-ch-div1">
                <ul class="qm-ch-ul">
                  <li>
                    <a href="javascript:;" class="zcBtn"
                      >在线客服
                      <img
                        src="../../assets/image/kf_red.png"
                        style="width:16px;height:16px;"
                    /></a>
                  </li>
                  <!-- <li><a href="http://wpa.b.qq.com/cgi/wpa.php?ln=2&amp;uin=4000513256" target="_blank">QQ客服<img src="http://www.zhaojiafang.com/shop/templates/default/images/qqt.png"></a></li> -->
                  <li>
                    <a href="javascript:;"
                      >微信客服
                      <img
                        src="../../assets/image/wx1.png"
                        style="width:16px;height:16px;"
                    /></a>
                    <img
                      :src="
                        CurrentEnvPrefix.main +
                          '/shop/templates/default/images/wxkf.jpg'
                      "
                      style="margin:5px;"
                    />
                    <!-- <span>微信扫一扫</span> -->
                  </li>
                </ul>
              </div>
            </li>
            <li class="qm-ul-li qm-ul-li-rx">
              <div class="ng-nav-tel">
                <span class="ng-tel-title">服务热线：</span>
                <span class="ng-tel-nub">400-0513-256</span>
              </div>
            </li>

            <li class="qm-ul-li qm-ul-li-wx">
              <div class="qm-ch-div">
                <a href="javascript:;"
                  ><img
                    src="../../assets/image/mobileversion.png"
                    style="width:10px;"/>
                  手机版 <i class="fa fa-angle-down" aria-hidden="true"></i
                ></a>
              </div>
              <div
                class="qm-ch-div1"
                style="display:block;background-color:transparent;border:none;padding-top:10px;"
              >
                <ul class="qm-ch-ul">
                  <li>
                    <a href="javascript:;">
                      <img
                        src="../../assets/image/appcode1.png"
                        style="width:94px;"
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div
                class="qm-ch-div1"
                style="background-color:transparent;border:none;padding-top:30px;width:210px;"
              >
                <ul
                  class="qm-ch-ul"
                  style="margin: 10px 0 0 0;width: 210px;height: 400px;border-radius: 4px;background: rgba(255, 255, 255, 1);box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 10%);padding: 6px;box-sizing: border-box;padding:6px;"
                >
                  <li
                    style="border-bottom: 1px dashed rgba(204, 204, 204, 1);padding-bottom: 6px;width: 100%;display: inline-block;"
                  >
                    <img
                      src="../../assets/image/appcode.png"
                      style="width:88px;float:left;"
                    />
                    <div
                      style="margin-left:94px;color:rgba(56, 56, 56,1);font-size:12px;padding-top:26px;"
                    >
                      <p style="line-height:20px;">下载找家纺APP</p>
                      <p style="color:rgba(102, 102, 102, 1);line-height:20px;">
                        数千厂家 数万货源
                      </p>
                    </div>
                  </li>
                  <li
                    style="border-bottom: 1px dashed rgba(204, 204, 204, 1);padding: 6px 0;width: 100%;display: inline-block;"
                  >
                    <img
                      src="../../assets/image/wxcode.png"
                      style="width:88px;float:left;"
                    />
                    <div
                      style="margin-left:94px;color:rgba(56, 56, 56,1);font-size:12px;padding-top:26px;"
                    >
                      <p style="line-height:20px;">关注微信公众号</p>
                      <p style="color:rgba(102, 102, 102, 1);line-height:20px;">
                        数千厂家 数万货源
                      </p>
                    </div>
                  </li>
                  <li
                    style="padding-top: 6px;width: 100%;display: inline-block;border-bottom: 1px dashed rgba(204, 204, 204, 1);"
                  >
                    <img
                      src="../../assets/image/smcode.png"
                      style="width:88px;float:left;"
                    />
                    <div
                      style="margin-left:94px;color:rgba(56, 56, 56, 1);font-size:12px;padding-top:26px;"
                    >
                      <p style="line-height:20px;">扫码进群</p>
                      <p style="color:rgba(102, 102, 102, 1);line-height:20px;">
                        领取运费优惠券
                      </p>
                    </div>
                  </li>
                  <li style="padding: 6px 0;width: 100%;display: inline-block;">
                    <img
                      src="../../assets/image/appletscode.png"
                      style="width:88px;float:left;"
                    />
                    <div
                      style="margin-left:94px;color:rgba(56, 56, 56, 1);font-size:12px;padding-top:26px;"
                    >
                      <p style="line-height:20px;">找家纺小程序</p>
                      <p style="color:rgba(102, 102, 102, 1);line-height:20px;">
                        使用微信扫一扫
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.input-file {
  display: none;
}
</style>
<script>
import Cookies from "js-cookie";
import { CurrentEnvPrefix } from "config/urlprefix.js";
import _common from "../../global/js/common";
export default {
  data() {
    return {
      CurrentEnvPrefix,
      membername: "",
      ref_url: "",
      member_mobile: "",
      userLink: "",
      orderListLink: ""
    };
  },
  methods: {
    checkPower(modules) {
      return this.$Api.get({
        api: this.Common.getSourec().plapi + "/alpha_test/check_power",
        param: { modules }
      });
    },
    memberLink(e) {
      this.userLink = _common.getlinkToErpUrl("/#/account/info", "", false);
      this.orderListLink = _common.getlinkToErpUrl(
        "/#/trade/orderhandle",
        "&key=0",
        false
      );
    },
    goout() {
      window.location.href =
        CurrentEnvPrefix.login +
        "/login/index/logout?rewrite_url=" +
        this.ref_url;
    },
    uploadChange(e) {
      var files = e.target.files[0];
      var _formData = new FormData();
      const _this = this;
      _formData.append("name", "card_z");
      _formData.append("key", this.$Api.getMKey());
      _formData.append("card_z", files);
      this.$Api
        .uploadResource(
          {
            api: "/mobile/index.php?act=goods&op=search",
            formdata: _formData
          },
          function(callbackProgress) {
            _this.$nextTick(() => {
              _this.progress = callbackProgress;
              // console.log(_this.progress)
            });
          },
          function(callBackResult) {
            //处理数据，跳到goodslist页面
            var param = callBackResult.data || [];
            var result = param.length > 0 ? param[0] : null;
            if (result) {
              var href =
                CurrentEnvPrefix.main +
                "/shop/index.php?act=search&op=goods_search&goods_id_list=" +
                result;
              window.location.href = href;
            }
          }
        )
        .then(response => {});
    }
  },
  mounted() {
    this.membername = Cookies.get("member_name") || "";
    this.member_mobile = Cookies.get("member_mobile") || "";
    if (Cookies.get("key")) {
      this.$Api.setMKey(Cookies.get("key"));
      this.memberLink();
    }
    this.ref_url = encodeURIComponent(window.location.href);

    var member_name = Cookies.get("member_name");
    var member_mobile = Cookies.get("member_mobile");
    var member_id = Cookies.get("partner_id");
    (function(w, d, e, x) {
      w[e] = function() {
        w.cbk = w.cbk || [];
        w.cbk.push(arguments);
      };
      x = d.createElement("script");
      x.async = true;
      x.id = "zhichiScript";
      (x.className = "zcBtn"), //该class可自行设置，只需要在使用的自定义入口上同名即可
        (x.src =
          "https://zhaojiafang.sobot.com/chat/frame/v2/entrance.js?sysnum=d3dd5834838542328e73eddfc2c64bd6");
      d.body.appendChild(x);
    })(window, document, "zc");
    zc("config", {
      //设置自定义按钮生效
      custom: true,
      to_customsys_open_style: 1,
      msg_flag: 1,
      uname: member_name,
      // tel:member_mobile,
      partnerid: member_id
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/public/publictop.vue